module.exports = __webpack_public_path__ + "img/vlag-en.83d54d7f22a2ffee1a90503808dcda21.svg";